import {take} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { User } from '../../authentication/services/authentication.service';
import { Observable } from 'rxjs';
import { Page } from '../../shared/models/page.model';
import { UserDTO } from '../../authentication/models/login';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private apiUrlUser = environment.apiUrl + '/api/users/';

  constructor(private http: HttpClient) {
  }

  findAllUsers() {
    return this.http.get<any>(`${this.apiUrlUser}listAll`).pipe(take(1));
  }

  findUsersWithOrders() {
    return this.http.get<any>(`${this.apiUrlUser}listAllWithOrder`).pipe(take(1));
  }

  findUserByUsername(username: string) {
    return this.http.get<any>(`${environment.authUrl}/api/ldap/username/${username}`).pipe(take(1))
  }

  PostUser(user: User) : Observable<User>{
    return this.http.post<User>(`${this.apiUrlUser}create`, user)
  }

  GetUsers(page: number, size:number, filter: string): Observable<Page<UserDTO>>{
    let params = new HttpParams()
      .append('page', page.toString())
      .append('size', size.toString())
      .append('filter', filter);

    return this.http.get<Page<UserDTO>>(`${this.apiUrlUser}list`, { params });
  }

  PutUser(user: User, id: number) : Observable<User>{
    return this.http.put<User>(`${this.apiUrlUser}${id}`, user)
  }

  DeleteUser(id: number) : Observable<any>{
    return this.http.delete<any>(`${this.apiUrlUser}${id}`)
  }
}
